<template>
  <div class="contact-card-single">
    <Upgrade-Popup
      v-if="showPopup"
      :upgradePopupType="upgradePopupType"
      v-on:clickedOutside="showPopup = false"
    />

    <Review-Popup
      v-if="showReviewPopup"
      v-on:reviewPopupClosed="showReviewPopup = false"
    />
    <Credit-Limit-Popup
      v-if="showCreditLimitPopup"
      v-on:clickedOutside="showCreditLimitPopup = false"
    />
    <Activation-Popup
      v-if="showActivationPopup"
      v-on:closed="showActivationPopup = false"
    />

    <Linkedin-Connect-Popup
      v-if="showLinkedInConnect"
      v-on:success="
        showLinkedInConnect = false
        triggerViewEmail()
      "
      v-on:failed="
        showLinkedInConnect = false
        showUpgradePopup('li_connect_multi')
      "
      v-on:close="showLinkedInConnect = false"
      v-on:skip="
        showLinkedInConnect = false
        showUpgradePopup('li_connect_skip')
      "
    />

    <div v-if="!loading && profileData" class="user-info animate-fadein">
      <div class="name-section">
        <div class="image-placeholder flex-c">
          {{ profileData.firstName ? profileData.firstName.slice(0, 1) : ''
          }}{{ profileData.lastName ? profileData.lastName.slice(0, 1) : '' }}
        </div>
        <div class="user-name-title-section">
          <div class="name width-100" v-if="profileData.fullName">
            {{ profileData.fullName }}
          </div>
          <div class="title float-l width-100" v-if="profileData.title">
            {{ profileData.title }}
          </div>
        </div>
      </div>
      <Spinner v-if="loadingSpinnerEmail || dataLoadingInBg" />
      <div class="user-email-section" v-else>
        <div
          class="get-email-btn"
          v-if="!profileData.email && !errorMsg.msg && !errorMsg.butText"
        >
          <V-Button
            :callback="findEmailSmtp"
            :text="'Find email'"
            :loading="false"
          />
        </div>
        <div
          v-if="!profileData.email && errorMsg && errorMsg.butText"
          class="diff-domain-section"
        >
          <Add-Domain-Find-Email-But
            class="flex-c"
            :text="errorMsg.butText"
            :type="'domain'"
            :data="profileData"
            v-on:newDomainSubmitted="findEmailWithCustomDomain"
          />
        </div>

        <div class="email-section animate-fadein" v-if="profileData.email">
          <Email-Icon
            viewBox="2 5 22 12"
            width="16px"
            height="16px"
            class="ref-icon"
          />
          <div class="text-section flex-c">
            <span class="value noselect ellipsis" :title="profileData.email">{{
              profileData.email
            }}</span>
            <div v-if="profileData.emailDeliverability && canShowButton()">
              <Email-confidence-card
                class="fn-14"
                :score="profileData.emailDeliverability"
              />
            </div>
            <div class="copy-section" v-if="canShowButton()">
              <div
                class="copy-wrap"
                title="Click to Copy"
                @click="
                  copyClipboard(
                    profileData.mcId
                      ? profileData.mcId
                      : profileData.masterContactId,
                    profileData.email,
                    'email'
                  )
                "
              >
                <input
                  type="text"
                  :value="profileData.email"
                  class="noVisibility"
                  :id="
                    (profileData.mcId
                      ? profileData.mcId
                      : profileData.masterContactId) + 'email'
                  "
                />
                <Copy-Icon width="16" height="16" />
              </div>
              <div>
                <Try-Different-Domain-Icon
                  v-if="
                    profileData.email &&
                    profileData.contactAlreadyOwned === true
                  "
                  :text="'Try for a different domain'"
                  :type="'domain'"
                  :data="profileData"
                  v-on:newDomainSubmitted="findEmailWithCustomDomain"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="get-email-btn" v-if="showFindEmailButton">
          <Find-Email-Button
            ref="viewEmailButton"
            :contactName="profileData.fullName"
            :contactCompany="profileData.companyName"
            :masterContactId="profileData.masterContactId"
            v-on:response="updateEmail"
            :showUpgradePopup="showUpgradePopup"
            :enableReviewPopup="enableReviewPopup"
            :showActivationPopup="showActivationError"
            :showLinkedInConnect="showLinkedInConnectPrompt"
            :fromLiSingle="true"
            :enableSalesgearPromotionPopup="enableSalesgearPromotionPopup"
          />
        </div>
      </div>
      <Phone-Section
        :contactId="
          profileData.mcId ? profileData.mcId : profileData.masterContactId
        "
        :email="profileData.email"
        :errorMsg="errorMsg && errorMsg.butText"
        :profileData="profileData"
        :updatePhone="updatePhone"
        :showUpgradePopup="showUpgradePopup"
        pageName="singleProfile"
      />
      <div class="create-add-list" v-if="profileData.contactAlreadyOwned">
        <Create-List
          :contactId="[
            profileData.mcId ? profileData.mcId : profileData.masterContactId,
          ]"
          :listType="'single'"
          v-on:addToListUpgrade="showUpgradePopup"
          :showActivationPopup="showActivationError"
        />
      </div>
      <div class="crm-section" v-if="canShowCRMButton">
        <Crm-Export
          :userEmail="profileData.email"
          v-on:crmUpgradePopup="showUpgradePopup"
          :contactData="profileData"
          :contactId="
            profileData.mcId ? profileData.mcId : profileData.masterContactId
          "
          :pageType="'single'"
          :companyData="companyData"
          :showActivationPopup="showActivationError"
        />
      </div>
      <div
        class="user-detail-section"
        v-if="profileData.level || profileData.department"
      >
        <!-- <div v-if="profileData.phone" class="phone-info">
          <div
            class="txt-blue"
            v-for="(ele, index) in profileData.phone"
            :key="index"
          >
            <Phone-Card
              v-if="ele.score == 'high'"
              :phone="ele"
              :contactsOwned="profileData.contactAlreadyOwned"
              :profileData="profileData"
            />
          </div>
        </div> -->

        <div class="level" v-if="profileData.level">
          <Contact-Icon width="16" height="16" viewBox="0 0 20 20" />
          <span>{{ getLevelNameFromLevel(profileData.level) }}</span>
        </div>
        <div class="portfolio" v-if="profileData.department">
          <Portfolio width="16" height="16" viewBox="0 0 20 20" />
          <span>{{ profileData.department.join(', ') }}</span>
        </div>
      </div>
    </div>

    <div v-else class="placeholder">
      <div class="name-title-section user-info">
        <div class="image-placeholder flex-c linear-background"></div>
        <div class="user-name-title-section">
          <div class="name width-100 linear-background"></div>
          <div class="title float-l width-100 linear-background"></div>
        </div>
      </div>
      <div class="email-card"></div>
      <div class="crm-section">
        <Crm-Export-Loader />
      </div>
      <div class="user-card">
        <div class="d-flex">
          <div class="icon linear-background"></div>
          <div class="label-name linear-background"></div>
        </div>
      </div>

      <div class="user-card">
        <div class="d-flex">
          <div class="icon linear-background"></div>
          <div class="label-name linear-background"></div>
        </div>
        <div class="d-flex">
          <div class="icon linear-background"></div>
          <div class="label-name linear-background"></div>
        </div>
      </div>
    </div>

    <Company-Info
      :companyData="companyData"
      :loadingCompany="loadingCompany"
      pageType="Single"
      :showSocialLinks="false"
    />
  </div>
</template>

<script>
import emailConfidenceCard from '@/components/EmailConfidenceCard'
import findEmailButton from '@/components/FindEmailButton'
import Button from '@/components/Button.vue'
import UpgradePopup from '@/components/UpgradePopup.vue'
import CreditLimitPopup from '@/components/CreditLimitPopup.vue'
import ReviewPopup from '@/components/ReviewPopup.vue'
import ActivationPopup from '@/components/ActivationPopup.vue'
import LinkedinConnect from '@/components/LinkedinConnect.vue'
import CompanyInfo from '@/components/companyInfo.vue'
import PhoneSection from '@/components/phoneSection.vue'
import sharedFunctions from '@/assets/util/functions.js'
import emailIcon from '@/assets/icons/svg/email.svg'
import { post, get } from '@/assets/util/rest.js'
import {
  advanceSearchUrl,
  TRIGGERS_TRACK_TO_LB,
} from '@/assets/util/constants/constants.js'
import addDomainFindEmail from '@/components/AddDomainFindEmail'
import contactIcon from '@/assets/icons/svg/contact.svg'
import portfolioIcon from '@/assets/icons/svg/portfolio.svg'
import copyIcon from '@/assets/icons/svg/copy.svg'
import Spinner from '@/components/Spinner'
import { MxEvent } from '@/assets/util/constants/analytics'
import CrmExportLoader from '@/components/crmExport/CrmExportLoader.vue'
import CrmExport from '@/components/crmExport/CrmExport.vue'
import CreateList from '@/components/CreateList'
//import CreateListFloatingLabel from '@/components/CreatelistFloatingLabel'
import TryDifferentDomainIcon from '@/components/TryDifferentDomain'

export default {
  name: 'SingleContactCard',
  props: [
    'profileData',
    'loading',
    'companyData',
    'conatactCount',
    'loadingCompany',
    'error',
    'dataLoadingInBg',
  ],
  watch: {
    error: {
      handler(newValue, oldValue) {
        if (oldValue != newValue) {
          this.errorMsg = newValue
        }
      },
    },
    profileData: {
      handler() {
        this.errorMsg = { msg: null }
      },
    },
  },
  data: function () {
    return {
      trySMPT: false,
      addButtonLoading: false,
      smtpCompleted: false,
      showPopup: false,
      showCreditLimitPopup: false,
      errorMsg: {
        msg: null,
      },
      upgradePopupType: null,
      showReviewPopup: false,
      showActivationPopup: false,
      loadingSpinnerEmail: false,
      showCopyMsg: false,
      showLinkedInConnect: false,
      showDomainTooltip: false,
      showSalesgearSchedule: false,
      showSalesgearPromotionPopup: false,
    }
  },
  computed: {
    isSalesgearExportEnabled: function () {
      return this.$store.state.salesgear.showSalesgearExportOption
    },
    isPaidUser: function () {
      return this.$store.state.header.isPaidUser
    },
    isAccountVerified: function () {
      return this.$store.state.header.emailStatus == 0
    },
    canShowCRMButton() {
      return (
        this.profileData &&
        (this.profileData.email ||
          (Array.isArray(this.profileData.phoneNumberFromVendor) &&
            this.profileData.phoneNumberFromVendor.length > 0)) &&
        this.profileData.contactAlreadyOwned == true
      )
    },
    showFindEmailButton() {
      return this.profileData.email && this.profileData.email.indexOf('*') > -1
    },
  },
  components: {
    // 'Phone-Card': PhoneCard,
    'Email-confidence-card': emailConfidenceCard,
    'Email-Icon': emailIcon,
    'Add-Domain-Find-Email-But': addDomainFindEmail,
    'Contact-Icon': contactIcon,
    Portfolio: portfolioIcon,
    'Find-Email-Button': findEmailButton,
    'V-Button': Button,
    'Copy-Icon': copyIcon,
    'Upgrade-Popup': UpgradePopup,
    'Review-Popup': ReviewPopup,
    'Activation-Popup': ActivationPopup,
    'Linkedin-Connect-Popup': LinkedinConnect,
    Spinner: Spinner,
    'Crm-Export': CrmExport,
    'Crm-Export-Loader': CrmExportLoader,
    'Create-List': CreateList,
    'Try-Different-Domain-Icon': TryDifferentDomainIcon,
    'Credit-Limit-Popup': CreditLimitPopup,
    'Company-Info': CompanyInfo,
    'Phone-Section': PhoneSection,
  },
  methods: {
    updateEmail(res) {
      this.profileData.email = res.email
      this.profileData.mcId = res.masterContactId
      this.profileData.contactAlreadyOwned = true
    },
    updatePhone(phone) {
      const dataToUpdate = { phone }
      if (phone.length > 0) {
        dataToUpdate.contactAlreadyOwned = true
      }
      this.profileData = { ...this.profileData, ...dataToUpdate }
    },
    findEmailSmtp() {
      const filteredData = sharedFunctions.getFilteredData(
        this.profileData,
        false
      )
      this.findEmail(filteredData)
    },
    findEmailWithCustomDomain(inputData) {
      sharedFunctions.track(MxEvent.tryDifferentDomain, {}, this.$store.state)
      this.profileData.domain = inputData.domain
      this.profileData.companyName = inputData.companyName
      this.profileData.title = null
      this.profileData.level = null
      this.profileData.email = null
      this.profileData.phone = null
      this.profileData.department = null
      this.companyData = null
      this.errorMsg.msg = null
      let customData = {}
      customData.fullName =
        `${inputData.firstName || ''} ${inputData.lastName || ''}`.trim() ||
        this.profileData.fullName
      customData['experience'] = [
        {
          isVerifiedDomain: false,
          isActivelyWorking: true,
          domain: inputData.domain,
          companyName: inputData.companyName,
        },
      ]
      this.findEmail(customData)
    },
    doNothing() {},
    getLevelNameFromLevel(level) {
      let levelName = null
      if ('C-Level' === level || 'VP-Level' === level) {
        levelName = 'Decision maker'
      } else if ('Director-Level' === level) {
        levelName = 'Influencer'
      } else if ('Manager-Level' === level) {
        levelName = 'Champion'
      } else {
        levelName = level
      }
      return levelName
    },
    canShowButton() {
      return (
        this.profileData.domain &&
        this.profileData.email &&
        this.profileData.email.indexOf('*') === -1
      )
    },
    findEmail(data) {
      if (data) {
        this.loadingSpinnerEmail = true
        let that = this
        post('lp/email.htm', data)
          .then((response) => {
            setTimeout(function () {
              that.loadingSpinnerEmail = false
              if (response.status == 200) {
                response.json().then((res) => {
                  if (res.statusCode == '200') {
                    that.profileData = {
                      ...res.response,
                      phone:
                        res.response && res.response.phoneNumberFromVendor
                          ? res.response.phoneNumberFromVendor
                          : null,
                    }
                    that.profileData.contactAlreadyOwned = true
                    let companyId =
                      res.response && res.response.companyId
                        ? res.response.companyId
                        : ''
                    if (companyId != '') {
                      that.getCompanyData(companyId)
                      // that.getContactCount(companyId)
                    }
                    that.errorMsg = { msg: null }
                  } else if (res.statusCode == '400') {
                    that.showActivationError()
                  } else if (res.statusCode == '402') {
                    that.showUpgradePopup('views')
                  } else if (res.statusCode == '420') {
                    that.setShowCreditLimitPopup()
                  } else {
                    that.profileData ? (that.profileData.email = null) : ''
                    // console.log('respons msgs :' + res)
                    if (res.error && res.error[0] && res.error[0].code) {
                      that.errorMsg = that.getErrorMsg(res)
                    } else {
                      that.errorMsg = { msg: res.errorMessage }
                    }
                    sharedFunctions.showNotificationMsg(that.errorMsg.msg, 3000)
                  }
                })
              }
            }, 2000)
          })
          .catch((e) => {
            that.loadingSpinnerEmail = false
            console.log('error: ' + e)
          })
      }
    },
    copyClipboard(cId, mail, name) {
      if (this.canShowButton()) {
        let txtDisplay = 'Copied'
        const dataMap = {
          pageType: 'Single',
        }
        sharedFunctions.clickToCopy(
          cId,
          mail,
          name,
          null,
          dataMap,
          txtDisplay,
          this.$store.state
        )
      }
    },
    checkAndShowUnlimitedCopyPromo() {
      if (this.canShowUnlimitedCopyMsg()) {
        const that = this
        setTimeout(function () {
          that.upgradePopupType = 'promo_unlimited_copy'
          that.showPopup = true
        }, 2000)
      }
    },
    canShowUnlimitedCopyMsg() {
      const _KEY = 'unlimited_copy_msg_shown'
      const alreadyShown = localStorage.getItem(_KEY)
      if (alreadyShown || this.isPaidUser) {
        return false
      } else {
        localStorage.setItem(_KEY, true)
        return true
      }
    },
    showAllOtherContact(e) {
      let domain =
        e && e.currentTarget ? e.currentTarget.getAttribute('data-link') : ''
      const dataMap = {
        pageType: 'Single',
      }
      sharedFunctions.track(MxEvent.viewAllLeads, dataMap, this.$store.state)
      if (!this.isAccountVerified) this.showActivationError()
      else if (domain != '')
        window.open(
          advanceSearchUrl(
            domain,
            this.$store.state.header.uiVersion,
            TRIGGERS_TRACK_TO_LB.SINGLE_VIEW_CONTACTS
          )
        )
    },
    getErrorMsg(res) {
      return sharedFunctions.getRespectiveErrorMsg(res)
    },
    showUpgradePopup(type) {
      if (type === 'credit_limit') {
        this.setShowCreditLimitPopup()
      } else {
        this.upgradePopupType = type
        this.showPopup = true
      }
    },
    setShowCreditLimitPopup() {
      this.showCreditLimitPopup = true
    },
    showActivationError() {
      this.showActivationPopup = true
    },
    showLinkedInConnectPrompt() {
      this.showLinkedInConnect = true
    },
    enableReviewPopup() {
      this.showReviewPopup = true
    },
    enableSalesgearPromotionPopup() {
      this.showSalesgearPromotionPopup = true
    },
    getCompanyData(compId) {
      this.loadingCompany = true
      get('lp/getCompany.htm?id=' + compId)
        .then((response) => {
          this.loadingCompany = false
          if (response.status == 200) {
            response
              .json()
              .then((res) => {
                this.companyData = res
              })
              .catch((e) => {
                this.loadingCompany = false
                console.log('err: ' + e)
              })
          } else {
            this.loadingCompany = false
            console.log('status: ' + response.status)
          }
        })
        .catch((e) => {
          this.loadingCompany = false
          console.log('error: ' + e)
        })
    },
    // contact count not shown in new UI
    // getContactCount(compId) {
    //   get('lp/company/' + compId + '/contactCount.htm')
    //     .then(response => {
    //       if (response.status == 200) {
    //         response
    //           .json()
    //           .then(res => {
    //             this.conatactCount = res
    //           })
    //           .catch(e => {
    //             console.log('err: ' + e)
    //           })
    //       } else {
    //         console.log('status: ' + response.status)
    //       }
    //     })
    //     .catch(e => {
    //       console.log('error: ' + e)
    //     })
    // },
    formatLocationString(street, city, state, country) {
      let str = ''
      str = str + (street ? street + (city ? ', ' : '') : '')
      str = str + (city ? city + (state ? ', ' : '') : '')
      str = str + (state ? state + (country ? ', ' : '') : '')
      str = str + (country ? country + '' : '')
      return str
    },
    triggerViewEmail() {
      this.$refs.viewEmailButton.findEmail()
    },
    scheduleNow() {
      this.showSalesgearSchedule = false
    },
    setSalesgearSchedule() {
      if (localStorage.getItem('SalesgearIntroBanner')) {
        this.showSalesgearSchedule = false
      } else {
        this.showSalesgearSchedule = true
      }
    },
    canSchedule() {
      if (this.showSalesgearSchedule && this.profileData.email) {
        return !(
          this.profileData.email && this.profileData.email.indexOf('*') != -1
        )
      } else {
        return false
      }
    },
  },
  created() {
    this.setSalesgearSchedule()
  },
  beforeMount() {
    this.setSalesgearSchedule()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin sequneceStyle {
  cursor: pointer;

  .dropdown-wrapper {
    left: -20px;
    top: 35px;

    .sharp__pointer {
      left: 23px;
    }
  }

  .spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    > div {
      width: 6px;
      height: 6px;
    }
  }
}

.contact-card-single {
  width: 100%;
  color: $grey-color;
  position: relative;
  line-height: 1.5;
  margin-top: 15px;

  .user-info {
    display: flex;
    flex-direction: column;
    padding: 0 16px;

    .name-section {
      display: flex;
      align-items: center;
      gap: 15px;
    }
    .image-placeholder {
      justify-content: center;
      background: #ffffff;
      border: 1px solid rgba(102, 112, 128, 0.1);
      border-radius: 100px;
      min-width: 40px;
      width: 40px;
      height: 40px;
      color: #495567;
      font-size: 16px;
      line-height: 24px;
      font-family: 'Figtree-Medium';
    }
    .user-name-title-section {
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .name {
        font-size: 16px;
        line-height: 28px;
        color: #495567;
        font-family: 'Figtree-Bold';
        @extend .ellipsis;
      }
      .title {
        font-size: 14px;
        line-height: 24px;
        color: #667080;
        @extend .ellipsis;
      }
    }
    .user-email-section {
      padding: 20px 0px 15px 0;
      display: flex;
      justify-content: space-between;
      .get-email-btn::v-deep {
        margin: 0;
        button {
          margin-left: auto;
          font-size: 12px;
          line-height: 18px;
          position: relative;
          padding: 2px 8px;
          background: rgba(38, 72, 247, 0.05);
          border: 1.5px solid rgba(38, 72, 247, 0.2);
          border-radius: 6px;
          color: #2648f7;

          &:hover {
            background: #2648f7;
            border-color: #2648f7;
            color: #fff;
          }
        }
      }
      .email-section {
        .ref-icon {
          fill: #667080;
        }
      }
      .diff-domain-section {
        position: relative;
        width: 100%;
      }

      .create-add-list {
        padding: 20px 0 5px;
        transition: all 300ms ease;
      }
    }
    .email-section {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      align-items: center;
      flex-grow: 1;
      overflow: hidden;

      .text-section {
        position: relative;
        padding-left: 10px;
        width: 100%;
        line-height: initial;
        overflow: hidden;
        gap: 8px;

        .value {
          color: #495567;
          word-break: break-all;
          font-size: 16px;
          line-height: 22px;
        }
        .copy-section::v-deep {
          margin-left: auto;
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
          transition: all 300ms ease;

          .copy-wrap {
            position: relative;
            background: #ffffff;
            border: 1px solid rgba(102, 112, 128, 0.2);
            border-radius: 6px 0px 0px 6px;
            width: 34px;
            height: 28px;
            display: flex;
            justify-content: center;
            margin-right: -1px;
            align-items: center;
            cursor: pointer;
            transition: all 300ms ease;

            &:hover svg g {
              opacity: 1;
              stroke: $primary-color;
            }
            &:hover {
              z-index: 1;
              border-color: $primary-color;
            }
            input {
              border: none;
              width: 100%;
              height: 1px;
              opacity: 0;
              box-shadow: none;
              outline: none;
              position: absolute;
              top: 10px;
              left: 5px;
              z-index: -1;
            }
          }
        }
      }
    }
    .crm-section {
      margin: 25px -25px;
      padding: 15px 25px;
      background: #f8f9fe;
      transition: all 300ms ease;
    }
    .user-detail-section {
      display: flex;
      flex-direction: column;
      margin-bottom: 25px;

      // .phone-info {
      //   width: 100%;
      //   display: grid;
      //   grid-template-columns: repeat(1, 1fr);
      //   padding: 5px 0;
      // .phone-card::v-deep {
      //   color: #636a72;
      //   .phone-title {
      //     font-size: 13px;
      //   }
      //   svg {
      //     width: 16px;
      //     height: 16px;
      //     fill: $icon-black;
      //     display: flex;
      //   }
      //   i {
      //     font-size: 24px;
      //   }
      // }
      // }

      .portfolio {
        padding-top: 15px;
      }
      .level,
      .portfolio {
        display: flex;
        align-items: center;

        span {
          margin-left: 10px;
          font-size: 15px;
          line-height: 22px;
          color: #495567;
        }
      }
    }
  }
}

.placeholder {
  .linear-background {
    margin-top: 10px;
    min-height: 15px;
    border-radius: 3px;
  }
  .name-title-section {
    flex-direction: row;
    padding: 10px 25px 20px;
    gap: 20px;
    .user-name-title-section > div {
      min-width: 200px;
    }
  }
  .email-card {
    background: #f6f6f6;
    height: 150px;
  }
  .crm-section {
    padding: 10px 25px;
  }

  .user-card {
    padding: 0 25px;
  }

  .user-card {
    display: flex;
    flex-direction: column;

    .icon {
      width: 20px;
      height: 15px;
      margin-right: 15px;
      margin-bottom: 20px;
    }

    .label-name {
      min-width: 200px;
    }
  }
}
::v-deep .company-info-section {
  border-top: 1px solid #e0e4ea;
}
</style>
